import styles from "./profilePolicy.module.css"
import {Link} from "react-router-dom";
import {ProfilePolicyWrapper} from "../../container/accountSettings.styles";
const ProfilePolicy = () =>{
    return (
        <ProfilePolicyWrapper>

            <Link className={styles.link} to="/akjdnmsadad"> Profile & Preferences</Link>
            <Link className={styles.link} to="/akjdnmsadad"> Privacy Policy</Link>


        </ProfilePolicyWrapper>
    )
}
export default ProfilePolicy